import { render, staticRenderFns } from "./ParameterIssues.vue?vue&type=template&id=d0c25564&"
import script from "./ParameterIssues.vue?vue&type=script&lang=ts&"
export * from "./ParameterIssues.vue?vue&type=script&lang=ts&"
import style0 from "./ParameterIssues.vue?vue&type=style&index=0&id=d0c25564&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports